// extracted by mini-css-extract-plugin
export default {"wrapper":"Yn-z","response":"Zn-z","error":"_n-z","disabled":"ao-z","buttons":"bo-z","feedbackQuestionSection":"co-z","yesNoWrapper":"do-z"};